module.exports = __webpack_public_path__ + "static/media/DRAGON.a77f14f0.png";